import { savePreference, clearPreferences } from "../actions/preferences";
import { VALID_PREFERENCES } from "../constants/preferences";

const c = window.console;

class Console {
  constructor(reduxStore) {
    this.store = reduxStore;
    console.warn(
      "*** This console is intended for development purposes. Use at your own risk! ***"
    );
    console.info('Initialized Console.  Run "help()" for a list of commands');
  }

  prefs = () => {
    const availablePrefs = VALID_PREFERENCES.reduce((a, b) => {
      a[b] = undefined;
      return a;
    }, {});
    const prefObject = {
      ...availablePrefs,
      ...this.store.getState().preferences
    };
    const keys = Object.keys(prefObject);
    const length = keys.reduce((carry, item) => {
      return carry > item.length ? carry : item.length;
    }, 0);
    c.group("Preferences");
    keys.forEach(key => {
      c.log(key.padStart(length, " ") + ":", prefObject[key]);
    });
    c.groupEnd();
  };

  setPref = (key, val) => {
    try {
      this.store.dispatch(savePreference(key, val));
      console.info("OK");
    } catch (err) {
      console.error(err);
    }
  };

  clearPrefs = () => {
    try {
      this.store.dispatch(clearPreferences());
      console.info("OK");
    } catch (err) {
      console.error(err);
    }
  };

  state = (asJson = false) => {
    if (asJson) {
      console.log(JSON.stringify(this.store.getState(), null, 2));
    } else {
      console.dir(this.store.getState());
    }
  };

  copyState = () => {
    if (window.copy) {
      window.copy(JSON.stringify(this.store.getState(), null, 2));
      console.log("Copied state to clipboard!");
    } else {
      console.error("Your JS console does not support the copy command");
    }
  };

  whoami = () => {
    const auth = this.store.getState().auth;
    console.group("Current User");
    console.log("      Name: ", auth.alias);
    console.log("Student Id: ", auth.studentId);
    console.log("  Group Id: ", auth.groupId);
    console.log("    GDL Id: ", window.sessionStorage.getItem("gdl_id"));
    console.groupEnd();
  };

  help = () => {
    console.group("Available Commands");
    console.log("prefs()           - Show a list of user preferences");
    console.log("setPref(key, val) - Set a preference");
    console.log("clearPrefs()      - Clears all stored preferences");
    console.log("whoami()          - Shows currently logged in user");
    console.log("state(asJson?)    - Prints the current application state");
    console.log("copyState()       - Copy state to clipboard");
    console.groupEnd();
  };
}

export default Console;
